import apiService from "../rest";
import { OAPI_API_TYPE } from "@/utils";
import { DateTime } from "luxon";
import errorLoggerAdapter from "@/adapters/errorLoggerAdapter";

class CheckoutService {
  static async post(rootGetters, dispatch, payload) {
    const venueId = rootGetters["venue/getActiveVenue"];
    const vendorId = rootGetters["vendor/getActiveVendor"].id;

    try {
      if (rootGetters["venueSettings/APIType"] === OAPI_API_TYPE) {
        //Get current time in UTC format to compare with expiration time
        const nowUtc = DateTime.utc().toMillis();
        //if cart is expired run cart calculate again
        if (nowUtc >= rootGetters["cart/getOAPICart"].cartExpirationTime)
          await dispatch("cart/validateCart", { promoCode: null }, { root: true });
      }

      const ppiReductions = rootGetters["cart/getPpiReductions"];
      const ppiAmenities = rootGetters["cart/getPpiAmenities"];

      //Create an array of all tenders involved in the order, duplicates are removed
      //IW needs to look at both applied amenities and reductions
      const involvedTenders = [
        ...new Map(
          [...ppiAmenities, ...ppiReductions].map((item) => [
            `${item.selectedTender.paymentType}${item.selectedTender.subpaymentType}`, //map key so it's unique
            { ...item.selectedTender } //tender information
          ])
        ).values()
      ];

      const checkoutPayload = {
        accountId: rootGetters["vendor/getActiveVendor"].defaultMobileOrderingAccountID,
        deviceOrderUuid: rootGetters["cart/getOAPICart"].deviceOrderUuid || "",
        deviceOrderId: rootGetters["cart/getDeviceOrderId"],
        paymentsData: payload,
        ppiPayments: rootGetters["cart/getPpiPayments"],
        redemptions: rootGetters["cart/getPpiRedemptions"],
        involvedTenders,
        total: String(rootGetters["cart/getFinalPrice"]()),
        subTotal: String(rootGetters["cart/getOAPISubTotal"]),
        discount: String(rootGetters["cart/getOAPITotalDiscounts"]),
        tax: String(rootGetters["cart/getOAPItotalTaxes"])
      };

      return await apiService.checkout(venueId, vendorId, checkoutPayload);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default CheckoutService;
